import React from 'react';
import { makeStyles } from '@material-ui/core';
import config from '../../preorder/configs/config.json';

const useStyle = makeStyles((theme) => ({
  root: {
    position: 'relative',
    backgroundSize: 'cover',
    backgroundImage: `url(${config.RESOURCE_URI}CS/W24_BulkpurchaseMenu.jpg)`,
  },
  container: {
    padding: theme.spacing(0),
    margin: 'auto',
    width: '100vw',
    height: 'calc(100vw/1921*12686)',
  },
}));

export default () => {
  const classes = useStyle();

  return (
    <div className={classes.root}>
      <div className={classes.container} />
    </div>
  );
};
